export const environment = {
  production: false,
  dataServicesURL: 'https://ptwfservices.wordflight.com/',
  assetServerURL: 'https://ptstudent.wordflight.com',
  studentSiteURL: 'https://ptstudent.wordflight.com',
  SENTRY_DSN: 'https://95f6a6cdcea2b81f37b0704585b64726@o4506633830989824.ingest.us.sentry.io/4507103776997376',
  CLEVER_REDIRECT_URI: 'https://ptwfservices.wordflight.com/clever/login',
  CLEVER_CLIENT_ID: '61055c415b22e16bc101',
  CLASSLINK_REDIRECT_URI: 'https://ptwfservices.wordflight.com/classlink/login',              
  CLASSLINK_CLIENT_ID: 'c1632169550751eae0c3c3c39e2ee2dec72ab90b24df',
  TYPOGRAPHY_URL: 'https://cloud.typography.com/7034538/7531232/css/fonts.css',
  versionNumber: '7.017',
  showAnnouncement: false,
  teacherReviewTimeoutHour: 1,
};
